/*
	Generated on 07/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React from 'react'
import { Link,useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth'
import { Button } from '@/commons/components';

import * as Layouts from "@/commons/layouts";
import setGrupMataKuliah from '../services/setGrupMataKuliah'

const GrupCard = ({ grupMataKuliahDataBinding }) => {
  const { checkPermission } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const pilih = async (grupItem) => {
    try {
      await setGrupMataKuliah({
        grupMataKuliahId: grupItem.id,
        id: id,
      });
  
      navigate(`/matakuliah/${id}`);
    } catch (error) {
    }
  };

  return (
    <Layouts.ListComponentCardLayout
      items={[grupMataKuliahDataBinding]}
      isRow
      isSearchable
      itemsAttrs={[
        {
          id: "kodeGrup",
          condition: "",
          label: "Kode Grup",
          featureName: "kode",
          editable: false
        },
        {
          id: "daftarMataKuliah",
          condition: "",
          label: "Daftar Mata Kuliah",
          featureName: "daftarMataKuliah",
          editable: false
        }
      ]}
      itemsEvents={(grupItem) => [
        <Link to=''>
          <Button 
            variant="secondary"
            onClick={() => pilih(grupItem)}
          >
            Pilih
          </Button>
        </Link>
      ]}
    />
  );
};

export default GrupCard;
